import React, {useEffect, useState, useRef} from 'react';
import {
    CircularProgress,
    Dialog,
    DialogContent,
    IconButton,
    InputLabel, ListItem,
    Select,
    TextField,
    Typography,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import JumboCardQuick from "@jumbo/components/JumboCardQuick";
import {useTranslation} from "react-i18next";
import {getCustomDateTime} from "@jumbo/utils";
import Button from "@mui/material/Button";

import Add from "@mui/icons-material/Add";
import DataTablesEmployee from "./DataTablesEmployee";
import Close from "@mui/icons-material/Close";
import Div from "@jumbo/shared/Div";
import DndWrapper from "../../extensions/dropzone/components/DndWrapper";
import List from "@mui/material/List";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import DataTablesTransaction from "./DataTablesTransaction";
import {
    GetProfile, EditProfileUser, ListEmployee
} from "../../../../api/api";
import Swal from "sweetalert2";


const Toast = Swal.mixin({
    toast: true,
    position: 'top-end',
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
    didOpen: (toast) => {
        toast.addEventListener('mouseenter', Swal.stopTimer)
        toast.addEventListener('mouseleave', Swal.resumeTimer)
    }
})


const EditProfile = () => {

    const [name, setName] = useState('');
    const [number, setNumber] = useState('');
    const [email, setEmail] = useState('');
    const [description, setDescription] = useState('');
    const [address, setAddress] = useState('');
    const [loaderedit, setLoaderedit] = useState('');

    const onname = (e) => {
        setName(e.target.value);
    };
    const onnumber = (e) => {
        setNumber(e.target.value);
    };
    const onemial = (e) => {
        setEmail(e.target.value);
    };
    const onDescription = (e) => {
        setDescription(e.target.value);
    };

    const onAddress = (e) => {
        setAddress(e.target.value);
    };


    useEffect(() => {

        // var bodyFormData = new FormData();
        // bodyFormData.append('Guest', false);
        GetProfile()
            .then((response) => {
                setName(response.data.profile.companyname);
                setNumber(response.data.profile.mobile);
                setEmail(response.data.profile.email);
                setDescription(response.data.profile.description);
                setAddress(response.data.profile.address);

            })
            .catch((error) => {


            });


    }, []);


    const onEditProfile = (e) => {

        setLoaderedit(true);

        var bodyFormData = new FormData();
        bodyFormData.append('name', name);
        bodyFormData.append('number', number);
        bodyFormData.append('description', description);
        bodyFormData.append('address', address);
        bodyFormData.append('email', email);
        EditProfileUser(bodyFormData)
            .then((response) => {
                setLoaderedit(false);
                setName(response.data.profile.companyname);
                setNumber(response.data.profile.mobile);
                setEmail(response.data.profile.email);
                setDescription(response.data.profile.description);
                setAddress(response.data.profile.address);

                Toast.fire({
                    icon: 'success',
                    title: response.data.errorDescription
                })

            })
            .catch((error) => {
                setLoaderedit(false);


            });


    }


    return (

        <React.Fragment>


            <JumboCardQuick
                title={'ویرایش مشخصات'}
                wrapperSx={{p: 3}}
            >

                <Grid container spacing={2}>
                    <Grid item md={4} xs={12}>
                        <TextField
                            inputProps={{style: {fontFamily: 'Iran'}}} // font size of input text
                            InputLabelProps={{style: {fontFamily: 'Iran'}}} // font size of input label
                            fullWidth
                            value={name}
                            disabled={true}
                            onChange={onname}
                            id="name" label="نام شرکت"
                            type="text" variant="outlined">
                        </TextField>
                    </Grid>

                    <Grid item md={4} xs={12}>
                        <TextField
                            inputProps={{style: {fontFamily: 'Iran'}}} // font size of input text
                            InputLabelProps={{style: {fontFamily: 'Iran'}}} // font size of input label
                            fullWidth
                            value={number}
                            onChange={onnumber}
                            id="name" label="شماره تماس"
                            type="number" variant="outlined">
                        </TextField>
                        {/*<Item>xs=4</Item>*/}
                    </Grid>
                    <Grid item md={4} xs={12}>
                        <TextField
                            inputProps={{style: {fontFamily: 'Iran'}}} // font size of input text
                            InputLabelProps={{style: {fontFamily: 'Iran'}}} // font size of input label
                            fullWidth
                            value={email}
                            onChange={onemial}
                            id="email" label="ایمیل"
                            type="email" variant="outlined">
                        </TextField>
                        {/*<Item>xs=4</Item>*/}
                    </Grid>
                    <Grid item md={4} xs={12}>
                        <TextField
                            inputProps={{style: {fontFamily: 'Iran'}}} // font size of input text
                            InputLabelProps={{style: {fontFamily: 'Iran'}}} // font size of input label
                            value={description}
                            onChange={onDescription}
                            fullWidth label="توضیحات"
                            placeholder="توضیحات درباره شرکت"
                            multiline
                            rows={2}
                            maxRows={4}
                        />
                        {/*<Item>xs=8</Item>*/}
                    </Grid>


                    <Grid item md={4} xs={12}>
                        <TextField
                            inputProps={{style: {fontFamily: 'Iran'}}} // font size of input text
                            InputLabelProps={{style: {fontFamily: 'Iran'}}} // font size of input label
                            value={address}
                            onChange={onAddress}
                            fullWidth label="آدرس"
                            placeholder="آدرس"
                            multiline
                            rows={2}
                            maxRows={4}
                        />
                        {/*<Item>xs=8</Item>*/}
                    </Grid>

                    <Grid style={{height: 0}} item md={4} xs={12}>

                    </Grid>
                    {/*<Grid style={{height:0}} item md={4} xs={12}>*/}

                    {/*</Grid>*/}
                    {/*<Grid style={{height:0}} item md={4} xs={12}>*/}

                    {/*</Grid>*/}


                    {/*<Grid item md={4} xs={12}>*/}
                    {/*    <Button variant="contained" onClick={onEditProfile} style={{width: '100%', marginTop: 20}}*/}
                    {/*    >*/}
                    {/*        {loaderedit ?*/}
                    {/*            <CircularProgress style={{color: '#ffffff'}} size={24}/>*/}
                    {/*            :*/}
                    {/*            <div style={{*/}
                    {/*                fontSize: 17,*/}
                    {/*                 fontFamily: 'Iran',*/}
                    {/*                fontWeight: 'bold',*/}
                    {/*                color: '#fff'*/}
                    {/*            }}>ویرایش تغییرات*/}
                    {/*            </div>*/}
                    {/*        }*/}

                    {/*    </Button>*/}
                    {/*</Grid>*/}


                </Grid>


                {/*<form className="row " noValidate autoComplete="off">*/}
                {/*    <div className="col-md-3 col-12  ">*/}
                {/*        <TextField*/}
                {/*            InputProps={{*/}
                {/*                classes: {*/}
                {/*                    root: classes.input,*/}
                {/*                },*/}
                {/*            }}*/}
                {/*            InputLabelProps={{*/}
                {/*                classes: {*/}
                {/*                    root: classes.input,*/}
                {/*                }*/}
                {/*            }}*/}
                {/*            fullWidth*/}
                {/*            value={name}*/}
                {/*            onChange={onname}*/}
                {/*            id="name" label="نام"*/}
                {/*            type="text" variant="outlined">*/}
                {/*        </TextField>*/}
                {/*    </div>*/}
                {/*    <div className="col-md-9 col-12  ">*/}

                {/*    </div>*/}
                {/*    <div className="col-md-3 col-12  ">*/}
                {/*        <TextField*/}
                {/*            InputProps={{*/}
                {/*                classes: {*/}
                {/*                    root: classes.input,*/}
                {/*                },*/}
                {/*            }}*/}
                {/*            InputLabelProps={{*/}
                {/*                classes: {*/}
                {/*                    root: classes.input,*/}
                {/*                }*/}
                {/*            }}*/}
                {/*            fullWidth*/}
                {/*            value={family}*/}
                {/*            onChange={onfamily}*/}
                {/*            style={{marginTop: 20}}*/}
                {/*            id="name" label="نام خانوادگی"*/}
                {/*            type="text" variant="outlined">*/}
                {/*        </TextField>*/}
                {/*    </div>*/}
                {/*    <div className="col-md-9 col-12  ">*/}

                {/*    </div>*/}
                {/*    <div className="col-md-3 col-12  ">*/}
                {/*        <TextField*/}
                {/*            InputProps={{*/}
                {/*                classes: {*/}
                {/*                    root: classes.input,*/}
                {/*                },*/}
                {/*            }}*/}
                {/*            InputLabelProps={{*/}
                {/*                classes: {*/}
                {/*                    root: classes.input,*/}
                {/*                }*/}
                {/*            }}*/}
                {/*            fullWidth*/}
                {/*            value={email}*/}
                {/*            onChange={onemail}*/}
                {/*            style={{marginTop: 20}}*/}
                {/*            id="name" label="نام سازمان"*/}
                {/*            type="text" variant="outlined">*/}
                {/*        </TextField>*/}
                {/*    </div>*/}
                {/*    <div className="col-md-9 col-12  ">*/}

                {/*    </div>*/}
                {/*    <div className="col-md-3 col-12  ">*/}
                {/*        <TextField*/}
                {/*            InputProps={{*/}
                {/*                classes: {*/}
                {/*                    root: classes.input,*/}
                {/*                },*/}
                {/*            }}*/}
                {/*            InputLabelProps={{*/}
                {/*                classes: {*/}
                {/*                    root: classes.input,*/}
                {/*                }*/}
                {/*            }}*/}
                {/*            fullWidth*/}
                {/*            value={mobile}*/}
                {/*            disabled={true}*/}
                {/*            onChange={onmobile}*/}
                {/*            style={{marginTop: 20}}*/}
                {/*            id="name" label="موبایل"*/}
                {/*            type="text" variant="outlined">*/}
                {/*        </TextField>*/}
                {/*    </div>*/}
                {/*    <div className="col-md-9 col-12  ">*/}

                {/*    </div>*/}


                {/*    <div className="col-md-3 col-12  ">*/}
                {/*        <TextField*/}
                {/*            InputProps={{*/}
                {/*                classes: {*/}
                {/*                    root: classes.input,*/}
                {/*                },*/}
                {/*            }}*/}
                {/*            InputLabelProps={{*/}
                {/*                classes: {*/}
                {/*                    root: classes.input,*/}
                {/*                }*/}
                {/*            }}*/}
                {/*            fullWidth*/}
                {/*            value={organisation}*/}
                {/*            onChange={onorganisation}*/}

                {/*            style={{marginTop: 20}}*/}
                {/*            id="name" label="نام دامنه"*/}
                {/*            type="text" variant="outlined">*/}
                {/*        </TextField>*/}
                {/*    </div>*/}
                {/*    <div className="col-md-9 col-12  ">*/}

                {/*    </div>*/}


                {/*    /!*<div className="col-md-3 col-12  ">*!/*/}
                {/*    /!*    <TextField*!/*/}
                {/*    /!*        InputProps={{*!/*/}
                {/*    /!*            classes: {*!/*/}
                {/*    /!*                root: classes.inputltr,*!/*/}
                {/*    /!*            },*!/*/}
                {/*    /!*        }}*!/*/}
                {/*    /!*        InputLabelProps={{*!/*/}
                {/*    /!*            classes: {*!/*/}
                {/*    /!*                root: classes.inputltr,*!/*/}
                {/*    /!*            }*!/*/}
                {/*    /!*        }}*!/*/}
                {/*    /!*        fullWidth*!/*/}
                {/*    /!*        value={card}*!/*/}
                {/*    /!*        onChange={oncard}*!/*/}
                {/*    /!*        style={{marginTop: 20}}*!/*/}
                {/*    /!*        id="number" label="شماره کارت"*!/*/}
                {/*    /!*        type="number" variant="outlined">*!/*/}
                {/*    /!*    </TextField>*!/*/}
                {/*    /!*</div>*!/*/}
                {/*    /!*<div className="col-md-9 col-12  ">*!/*/}

                {/*    /!*</div>*!/*/}


                {/*    <div className="col-md-3 col-12  ">*/}
                {/*        <TextField*/}
                {/*            InputProps={{*/}
                {/*                classes: {*/}
                {/*                    root: classes.input,*/}
                {/*                },*/}
                {/*            }}*/}
                {/*            InputLabelProps={{*/}
                {/*                classes: {*/}
                {/*                    root: classes.input,*/}
                {/*                }*/}
                {/*            }}*/}
                {/*            fullWidth*/}
                {/*            value={password}*/}
                {/*            onChange={onpassword}*/}
                {/*            style={{marginTop: 20}}*/}
                {/*            id="name" label="گذرواژه"*/}
                {/*            type="password" variant="outlined">*/}
                {/*        </TextField>*/}
                {/*    </div>*/}
                {/*    <div className="col-md-9 col-12  ">*/}

                {/*    </div>*/}
                {/*    <div className="col-md-3 col-12  ">*/}
                {/*        <TextField*/}
                {/*            InputProps={{*/}
                {/*                classes: {*/}
                {/*                    root: classes.input,*/}
                {/*                },*/}
                {/*            }}*/}
                {/*            InputLabelProps={{*/}
                {/*                classes: {*/}
                {/*                    root: classes.input,*/}
                {/*                }*/}
                {/*            }}*/}
                {/*            fullWidth*/}
                {/*            value={repassword}*/}
                {/*            onChange={onrepassword}*/}
                {/*            style={{marginTop: 20}}*/}
                {/*            id="name" label="تکرار گذرواژه"*/}
                {/*            type="password" variant="outlined">*/}
                {/*        </TextField>*/}
                {/*    </div>*/}
                {/*    <div className="col-md-9 col-12  ">*/}

                {/*    </div>*/}


                {/*</form>*/}


                {/*<div>*/}

                {/*    <Grid lg={6}>*/}
                {/*        <TextField*/}
                {/*            value={name}*/}
                {/*            onChange={onname}*/}
                {/*            id="name" label="نام"*/}
                {/*            type="text" variant="outlined">*/}
                {/*        </TextField>*/}
                {/*    </Grid>*/}


                {/*</div>*/}


            </JumboCardQuick>

            <div style={{
                marginTop: 20,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexDirection: 'row'
            }}>

                <div></div>


                <Button variant="contained" onClick={onEditProfile} style={{width: 170, marginTop: 10, height: 40, marginBottom: 40}}
                >
                    {loaderedit ?
                        <CircularProgress style={{color: '#ffffff'}} size={24}/>
                        :
                        <div style={{
                            fontSize: 15,
                            fontFamily: 'Iran',
                            fontWeight: 'bold',
                            color: '#fff'
                        }}>ویرایش تغییرات
                        </div>
                    }

                </Button>


                {/*<Button disabled={loadersave} onClick={onsaveprofile} variant="contained"*/}
                {/*        className="bg-primary text-white iran-font"*/}
                {/*        style={{width: 150, height: 40, marginTop: 10, marginBottom: 40}}>*/}

                {/*    <span className="iran-font3">ارسال</span>*/}
                {/*    {loadersave &&*/}
                {/*    <CircularProgress size={24} className="buttonProgress"/>}*/}


                {/*</Button>*/}

            </div>


        </React.Fragment>


    );
};

export default EditProfile;
